import { IMarket } from 'app/advanced-search/interfaces/advances-search.interface';

const all: IMarket = { name: 'ALL', id: null };
const usa: IMarket = { name: 'USA', id: 1 };
const europe: IMarket = { name: 'Europe', id: 2 };
const asia: IMarket = { name: 'Asia', id: 3 };
const canada: IMarket = { name: 'Canada', id: 4 };
const russia: IMarket = { name: 'Russia', id: 5 };

export const marketsStocks: IMarket[] = [all, usa, europe, asia, canada];
export const marketsFutures: IMarket[] = [all, usa, europe, asia, russia];
export const marketsFuturesCalc: IMarket[] = [all, usa, europe, asia];
export const marketsOIC: IMarket[] = [usa];
